import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, CardMedia, Typography, Button,CircularProgress,
   IconButton,
    Chip } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

// import FavoriteIcon from '@mui/icons-material/Favorite';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import ShareIcon from "@mui/icons-material/Share";

import { useParams,useNavigate } from "react-router-dom";
import { useMediaQuery, useTheme } from '@mui/material';
import BankDetailsModal from "./detailsbank";




const ProductDetails = ({ onClose }) => {
  const { productId } = useParams();
  const navigate = useNavigate();
  // eslint-disable-next-line
    const [favorites, setFavorites] = useState({});
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [loading, setLoading] = useState(false);

   // eslint-disable-next-line
  const [successMessage, setSuccessMessage] = useState("");
    //eslint-disable-next-line
  const [images, setImages] = useState([]);
  
  const [product, setProduct] = useState({
    title: "",
    categoryName: "",
    description: "",
    price: 0,
    location: "",
    promotionStatus: "",
    imagePaths: [],
    videoPath: "",
    postByUser: "",
  });
  
 

  const hasImages = product.imagePaths && product.imagePaths.length > 0;
  const hasVideo = Boolean(product.videoPath);

  // State to track the selected image
  const [selectedImage, setSelectedImage] = useState(
    hasImages ? product.imagePaths[0] : null
  );
    const theme = useTheme();
        const isDesktop = useMediaQuery(theme.breakpoints.up('md')); 
        const [showBankModal, setShowBankModal] = useState(false);  
        // eslint-disable-next-line  
    const [category, setCategory] = useState('');
    // eslint-disable-next-line
    const [title, setTitle] = useState('');
    // eslint-disable-next-line
    const [description, setDescription] = useState('');
    // eslint-disable-next-line
    const [price, setPrice] = useState('');
    // eslint-disable-next-line
    const [location, setLocation] = useState('');
  
  
    useEffect(() => {
      const fetchProduct = async () => {
        try {
          const token = localStorage.getItem("token"); // Retrieve token from localStorage
        
          const response = await fetch(
            `https://daradservice.azurewebsites.net/api/P2PProducts/get-product?productId=${productId}`,
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`, 
              },
            }
          );
    
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
    
          const data = await response.json();
       
          if (data.status) {
            const productData = data.data;
            setProduct(productData);
            setCategory(productData.categoryName || "");
            setTitle(productData.title || "");
            setDescription(productData.description || "");
            setPrice(productData.price || "");
            setLocation(productData.location || "");
    
          
            setImages(productData.imagePaths || []);
          }
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      };
    
      fetchProduct();
    }, [productId]);
    

    useEffect(() => {
      if (successMessage) {
        const timer = setTimeout(() => setSuccessMessage(""), 2000); // Clears after 2 sec
        return () => clearTimeout(timer);
      }
    }, [successMessage]);


   

    const [selectedProductId, setSelectedProductId] = useState(null);

    const handleMakeOrder = async () => {
      const token = localStorage.getItem("token"); 
      const userId = sessionStorage.getItem("userId"); 
    
      if (!userId || !productId || !token) {
        alert("You need to log in and select a product first.");
        return;
      }
    
      try {
        setLoading(true); // Start loader
    
        const response = await fetch(
          `https://daradservice.azurewebsites.net/api/P2PProducts/save-order?ProductId=${productId}&UserId=${userId}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        const data = await response.json();
        console.log("Make Order API Response:", data);
    
        if (response.ok && data.status) {
          setSelectedProductId(productId);
          setSelectedOrderId(data.data.orderId);
    
          setTimeout(() => {
            setShowBankModal(true);
          }, 100);
        }
      } catch (error) {
        console.error("Error making order:", error);
        alert("An error occurred while making the order. Please try again.");
      } finally {
        setLoading(false); // Stop loader
      }
    };
    
    
    useEffect(() => {
      if (selectedOrderId !== null) {
        console.log("Opening modal with Order ID:", selectedOrderId);
        setShowBankModal(true);
      }
    }, [selectedOrderId]);  
    


 // Filter products

 
 const toggleFavorite = async (productId) => {
   try {
     const token = localStorage.getItem("token");
     const customerEmail = sessionStorage.getItem("userEmail");
 
     if (!customerEmail) {
       console.error("No user email found in session storage");
       return;
     }
 
     setFavorites((prevFavorites) => ({
       ...prevFavorites,
       [productId]: !prevFavorites[productId], 
     }));
 
     const url = `https://daradservice.azurewebsites.net/api/P2PProducts/add-product-to-favorite?productId=${encodeURIComponent(productId)}&customerEmail=${encodeURIComponent(customerEmail)}`;
 
     const response = await fetch(url, {
       method: "POST",
       headers: {
         Accept: "text/plain",
         Authorization: `Bearer ${token}`,
       },
     });
 
     if (!response.ok) {
       throw new Error("Failed to add to favorites");
     }
 
     setSuccessMessage("Added to favorites successfully!");
     
 
   } catch (error) {
     console.error("Request failed:", error);
 
     setFavorites((prevFavorites) => ({
       ...prevFavorites,
       [productId]: !prevFavorites[productId], 
     }));
 
     setSuccessMessage("Failed to add to favorites.");
   
   }
 };
 



  
  return (



    <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      width: isDesktop ? "100%" : "100%",
      backgroundColor: "#F8F9FA",
      padding: { xs: 2, md: 3, sm:6, }, 
      position: "relative",
    }}
  
    >
      {/* Close Button */}
      <Box
  sx={{
    position: "absolute",
    top: { xs: 20, md: 40 },
    left: { xs: 10, md: 20 },
    zIndex: 10, // Ensures it's above other elements
  }}
>
  <IconButton
    onClick={() => navigate("/product/marketplace")}
    sx={{
      color: "white",
      background: "#5604F6",
      fontSize: "48px",
      borderRadius: "50px",
      "&:hover": { background: "#4503D6" }
    }}
  >
    <ArrowBackIcon />
  </IconButton>
</Box>


     
      <Card sx={{ display: "flex",
          flexDirection: isDesktop ? "row" : "column", 
          width: isDesktop ? "80%" : "100%",
          
         borderRadius: 3, boxShadow: 3, padding: 2, border: "1px solid #ddd" }}>
        {/* Left Side - Product Image */}

  
        <Box
  sx={{
    position: "relative",
    width: { xs: "90%", sm: "75%", md: "50%" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  {/* Main Media Section */}
  {hasVideo ? (
    <CardMedia
      component="video"
      controls
      src={product.videoPath}
      sx={{
        width: "100%",
        height: { xs: "250px", sm: "300px", md: "350px" },
        objectFit: "cover",
        borderRadius: 3,
      }}
    />
  ) : product.imagePaths.length > 0 ? (
    <CardMedia
      component="img"
      image={selectedImage || product.imagePaths[0]} // Show selected image or first image by default
      alt="Main Product Image"
      sx={{
        width: "100%",
        height: { xs: "250px", sm: "300px", md: "350px" },
        objectFit: "cover",
        borderRadius: 3,
      }}
    />
  ) : (
    <Typography>No Media Available</Typography>
  )}

  {/* Promotion Chip */}
  {product.promotionStatus === "Active" && (
    <Chip
      label="Promoted"
      sx={{
        position: "absolute",
        top: 15,
        left: 15,
        backgroundColor: "#F6A704",
        color: "black",
        fontWeight: "bold",
      }}
    />
  )}

  {/* Image Thumbnails */}
  {hasImages && product.imagePaths.length > 1 && (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        mt: 2,
        overflowX: "auto",
        width: "100%",
        justifyContent: "center",
        paddingX: 1,
      }}
    >
      {product.imagePaths.map((image, index) => (
        <CardMedia
          key={index}
          component="img"
          image={image}
          alt={`Product Image ${index + 1}`}
          onClick={() => setSelectedImage(image)}
          sx={{
            width: { xs: 80, sm: 100, md: 120 },
            height: { xs: 70, sm: 90, md: 100 },
            objectFit: "cover",
            borderRadius: 2,
            cursor: "pointer",
            transition: "transform 0.2s",
            border: selectedImage === image ? "2px solid #007bff" : "none",
            "&:hover": { transform: "scale(1.1)" },
          }}
        />
      ))}
    </Box>
  )}
</Box>


{successMessage && (
  <Box
    sx={{
      position: "fixed",
      bottom: 20,
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#4CAF50",
      color: "white",
      padding: "10px 15px",
      borderRadius: "8px",
      boxShadow: 3,
      fontSize: "14px",
      fontWeight: "bold",
      zIndex: 1000,
    }}
  >
    {successMessage}
  </Box>
)}

        {/* Right Side - Product Details */}
        <CardContent
          sx={{
            width: isDesktop ? "50%" : "100%",
            padding: isDesktop ? 3 : 2,
           display: "flex", flexDirection: "column", gap: 2 }}>
         <Box display="flex" alignItems="center" gap={2}>
 
  <Typography
    fontWeight="600"
    fontSize={isDesktop ? "32px" : "24px"} 
    fontFamily="Urbanist"
  >
    {product.title}
  </Typography>
</Box>
          <Box display="flex" justifyContent="space-between" gap={1}>
  <Typography 
    variant="body2" 
    sx={{ bgcolor: "#EEE6FE", color: "#5604F6", p: 1, borderRadius: 1 }}
  >
    {product.categoryName}
  </Typography>
  <Typography 
    variant="body2" 
    sx={{ color: "rgba(18, 18, 18, 0.8)", fontSize:"14px" ,  ...theme.typography.urbanist700,}}
  >
   Post by {product.postByUser}
  </Typography>
</Box>


          <Box sx={{ border: "1px solid #ddd", padding: 2, borderRadius: 2 }}>
            <Typography variant="body2" color="textSecondary">
            <Typography variant="body2" color="textSecondary" sx={{ color: "rgba(18, 18, 18, 0.8)", fontSize:"16px" , fontFamily: "Urbanist",fontWeight:"600"}}
  >
  {product.description}
</Typography>

            </Typography>
          </Box>
          <Box sx={{ border: "1px solid #ddd", padding: 2, borderRadius: 2, display: "flex", flexDirection: "column", gap: 1 }}>
           <Typography sx={{   ...theme.typography.urbanist800,fontSize: "32px", color: "#F6A704" }}>
           ₦{new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 }).format(product.price)}
           </Typography>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body2"  fontWeight={800}>Availability of the product:</Typography>
              <Typography  color="textSecondary" display="flex" sx={{ color: "rgba(18, 18, 18, 0.8)", fontSize:"16px" , fontFamily: "Urbanist",fontWeight:"700",  m:"10px"}}><Typography variant="body2" fontWeight={800}>
  {product.availability || ""}
</Typography>
</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" justifyContent="left" alignItems="center">
              <LocationOnIcon fontSize="small" color="action" />
              <Typography variant="body2" fontWeight={800}>Location:</Typography>
 </Box>
              <Typography variant="body2" color="textSecondary" display="flex" sx={{ color: "rgba(18, 18, 18, 0.8)", fontSize:"16px" , fontFamily: "Urbanist",fontWeight:"700",  m:"10px"}}>{product.location}</Typography>
            </Box>
           
          </Box>
          <Box 
  sx={{ 
    display: "flex", 
    flexDirection: isDesktop ? "row" : "column", 
    justifyContent: "space-between",
    gap: 2, 
    mt: 2 
  }}
>
  <Button
    variant="outlined"
    startIcon={<FavoriteBorderIcon />}
    sx={{
      flex: 1,
      borderColor: "#5604F6",
      color: "#5604F6",
      borderRadius: "999px",
      textTransform: "none",
      fontWeight: "bold",
      '&:hover': { backgroundColor: "rgba(86, 4, 246, 0.1)" },
    }}
    onClick={() => toggleFavorite(productId)}
  >

    {successMessage ? "Added to Favourite" : "Add to Favourite"}
  </Button>

  <Button
    variant="contained"
    sx={{
      flex: 1,
      backgroundColor: "#5604F6",
      color: "white",
      fontWeight: "bold",
      borderRadius: "999px",
    }}
    onClick={handleMakeOrder} 
    disabled={loading}
  >
  {loading ? (
    <CircularProgress size={24} sx={{ color: "#fff" }} />
  ) : (
    "Make Order"
  )}
  </Button>
</Box>

        </CardContent>
       
      </Card>

      <BankDetailsModal 
  open={showBankModal} 
  onClose={() => setShowBankModal(false)} 
  productId={selectedProductId} 
  price={product.price} 
  orderId={selectedOrderId}
/>

    </Box>
  );
};

export default ProductDetails;
